import React, { useRef }  from "react";
import { useTranslation } from "react-i18next";
import { CardHeading } from "../profile/index.style";
import { Row, Column } from "../../global/grid";
import Panel, { PanelHeader, PanelBody } from "../../global/panel";
import Button from "../../global/button";
import ChangePasswordModal from "../changePasswordModal";

const AccountInfo = ({ account }) => {
    const { t } = useTranslation("components.profile.accountInfo");
    const changeNameModal = useRef(null);

    const changePassword = () => {
        changeNameModal?.current && changeNameModal.current.open();
    };

    return (
        <>
            <Panel variant="shadowed">
                <PanelHeader>
                    <CardHeading>{t("title")}</CardHeading>
                </PanelHeader>
                <PanelBody>
                    <Row pb={{ _: 4, md: 0 }}>
                        <Column sm="12" md="4" py={{ md: 3 }}>{t("username")}</Column>
                        <Column sm="12" md="8" py={{ md: 3 }}>{account.usuario}</Column>
                    </Row>
                    <Row pb={{ _: 4, md: 0 }}>
                        <Column sm="12" md="4" py={{ md: 3 }}>{t("password")}</Column>
                        <Column sm="12" md="8" py={{ md: 3 }}>
                            {t("passwordPlaceholder")}
                            <Button colors="primary" size="sm" ml={{ _: "50px", md: "12px" }}
                                             onClick={changePassword}>{t("changePassword")}</Button>
                        </Column>
                    </Row>
                    {/*<Row pb={{ _: 4, md: 0 }}>*/}
                    {/*    <Column sm="12" py={{ md: 3 }}>*/}
                    {/*        <ButtonLink onClick={linkVoid}><strong>{t("closeAccount")}</strong></ButtonLink>*/}
                    {/*    </Column>*/}
                    {/*</Row>*/}
                </PanelBody>
            </Panel>
            <ChangePasswordModal account={account} innerRef={changeNameModal} />
        </>
    );
};

export default AccountInfo;
